import React from 'react';
import PropTypes from 'prop-types';
import _fp from 'lodash/fp';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import RouteCollection from '@bd/bdcore-named-routes';
import { Slugify, SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';
import PageMenu from '../../PageMenu';
// import LightBoxVideoList from '../../LightBoxVideoList';
import { colors } from '../../../styles';


const styles = css`
.PhotoGallery_categoryTitle {
  font-weight: 800;
  font-size: 24px;
  color: ${colors.body};
  letter-spacing: 4px;
  text-align: center;
  line-height: 36px;
  text-transform: uppercase;
  margin: 40px 0 80px 0;
  position: relative;
  @media (min-width: 992px) {
    font-size: 41px;
    margin: 0 0 80px 0;
  }
  &:after {
    content: '';
    position: absolute;
    display: block;
    width: 150px;
    height: 3px;
    left: 50%;
    margin-left: -75px;
    background-color: ${colors.neutral};
    bottom: -40px;
  }
}
.PhotoGallery_menu {
  @media (min-width: 992px) {
    background-color: transparent;
    padding: 30px 0 60px 0;
    ul {
      text-align: center !important;
      li a {
        color: ${colors.brand1Dark} !important;
        line-height: 30px !important;
        height: 29px;
        margin: 0 30px;
        border-radius: 14px;
        text-transform: none;
        font-size: 14px;
        font-weight: 700;
        margin: 0 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        border: 0 !important;
        &.active {
          color: ${colors.white} !important;
          background-color: ${colors.brand2} !important;
          border: 0 !important;
        }
      }
    }
  }
}
.VideoGallery_List {
    padding:3px;
  }
  .PhotoCard {
    width:100%;
    position: relative;
    padding:0;
    padding-top:56%;
    background-size: cover;
    background-position: center;
    border:3px solid white;
  }
  .PlayIcon {
    position:absolute;
    top:50%;
    margin-top:-30px;
    left:50%;
    margin-left:-30px;
    width:60px;
    height:60px;
    border-radius: 50%;
    border:4px solid white;
    text-align: center;
    display: flex;
    flex-flow:column wrap;
    justify-content: center;
    background:rgba(0,0,0,.4);
    .PlayIcon_triangle {
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 10px solid white;
      margin: 0 auto;
    }
  }
  .VideoList_Item {
    cursor:pointer;
  }
  .VideoList_Item:hover .PhotoList_content {
    opacity: 1;
  }
  .PhotoCard_title {
    padding:3px 3px 10px 3px;
  }
`;

const videoBoxStyle = css`
position: relative;
width: 80%;
padding-top: calc(80% * 0.5625);
margin-top: -22%;
top: 50%;
margin-left: 10%;

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
`;


function VideoGallery({ content = [], router, dataKey }) {
  const searchParams = new URLSearchParams(window.location.search);
  const searchParamSlug = searchParams.has(dataKey)
    ? Slugify(searchParams.get(dataKey))
    : undefined;
  const route = RouteCollection.getRouteByPath(_fp.get('location.pathname', router));
  const gallerySlug = _fp.getOr(searchParamSlug, `params.${dataKey}`, route);
  let activeGallery;
  let videos = [];

  if (gallerySlug) {
    activeGallery = content
      .find(g => Slugify(_fp.getOr('', 'category_name', g)) === gallerySlug);
    videos = _fp.getOr([], 'videos', activeGallery);
  } else {
    videos = _fp.flow(
      _fp.map('videos'),
      _fp.flatten,
    )(content);
  }

  const routeHasParam = _fp.some(Boolean, _fp.map(`keys.${dataKey}`, RouteCollection.getRoutes()[route.name]));
  const encode = !routeHasParam ? encodeURIComponent : v => v;

  const categoryLinks = content.map(g => ({
    name: route.name,
    [routeHasParam ? 'params' : 'query']: { [dataKey]: encode(_fp.get('category_name', g)) },
    title: _fp.get('category_name', g),
    hash: `#${dataKey}`,
  }));

  return (
    <div className={styles}>
      <PageMenu
        className="PhotoGallery_menu"
        title="Video Gallery Categories"
        items={[
          {
            name: route.name,
            title: 'All',
            hash: `#${dataKey}`,
          },
        ].concat(categoryLinks)}
      />
      <div className="container">
        <div className="row">
          <div className="col-12 pb-5">
            <LightBox
              onlyWithIndex
              items={videos.map(video => ({
                element: (
                  <div
                    className={videoBoxStyle}
                    dangerouslySetInnerHTML={SanitizeHtml(video.video)}
                  />
                ),
              }))}
            >
              <ul className="VideoGallery_List list-unstyled row m-0 justify-content-center">
                {
                  videos.map((video, i) => (
                    <li className="col-12 col-sm-6 p-0 col-xl-4 VideoList_Item" key={get('title', video)} data-index={i}>
                      {/* <YoutubeThumbnail
                        video={_.get('video', video)}
                        index={i}
                      /> */}
                      {/* <img src={_.get('thumbnail_preview.contentUrl', video)} alt="" /> */}
                      {/* <img src={buildThumbnailUrl(get(video, 'thumbnail_preview.contentUrl')
                      , { height: 450, width: 800, exact: true })} data-index={i} alt="" /> */}
                      <div className="PhotoCard" style={{ backgroundImage: `url(${buildThumbnailUrl(get(video, 'thumbnail_preview.contentUrl'), { width: 800, height: 450, exact: true })})` }}>
                        {/* <div className="Favorite-circle">
                          <FavoriteToggle
                            content={{
                              name: 'Video',
                              _id: video.video,
                              iframe: true,
                              imageUrl: get(video, 'thumbnail_preview.contentUrl'),
                            }}
                          />
                        </div> */}
                        <div className="PlayIcon">
                          <div className="PlayIcon_triangle" />
                        </div>
                      </div>
                      <div className="PhotoCard_title">{get(video, 'title')}</div>
                    </li>
                  ))
                }
                {
                  videos.length === 0 &&
                  <li>There are no videos at this time</li>
                }
              </ul>
            </LightBox>

            {/*
            <LightBoxVideoList
              show={12}
              gallery={_fp.get('category_name', activeGallery)}
              videos={videos}
              enableZoom
            />
            */}
          </div>
        </div>
      </div>
    </div>
  );
}

VideoGallery.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  router: PropTypes.object.isRequired,
  dataKey: PropTypes.string.isRequired,
};

export default withData({
  router: true,
})(VideoGallery);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/VideoGallery.section.js